module.exports = __webpack_public_path__ + "img/Family Mart.757b388f.svg";